// @ts-strict-ignore
import { IOperation } from './i-operation';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleVO } from '@article/model/vo/article.vo';
import { NumberUtils } from '../../util/number-utils';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { PropertyUtils } from '@article/util/property-utils';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ReplaceArticleService } from '@configuration/article/replace-article.service';

export class UndoReplaceArticleInContainerOperation implements IOperation {
  private _additionalNewUsageInfoProperties: PropertyVO[] = null;

  private _newLength: number = NaN;

  constructor(
    private _replaceArticleService: ReplaceArticleService,
    private _articleContainer: ArticleContainer,
    private _originalArticle: ArticleVO,
    private _newArticle: ArticleVO,
    private _additionalOriginalUsageInfoProperties: PropertyVO[],
    private _selectionModelService: SelectionModelService,
    private _applyOriginalLength: number = NaN
  ) {
    if (NumberUtils.isNumber(_applyOriginalLength)) {
      this._newLength = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(
        _articleContainer.articleUsage,
        ArticleUsageInfoPropertyDef.ARTICLE_LENGTH
      );
    }
  }

  public getOperationDescription(): string {
    return '';
  }

  public getQualifiedClassName(): string {
    return 'UndoReplaceArticleInContainerOperation';
  }

  public async performRedo(): Promise<void> {
    this._selectionModelService.removeAllSelections();
    if (NumberUtils.isNumber(this._applyOriginalLength)) {
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(
        this._articleContainer.articleUsage,
        ArticleUsageInfoPropertyDef.ARTICLE_LENGTH,
        this._newLength
      );
    }
    await this._replaceArticleService.replaceArticle(this._articleContainer, this._newArticle);
    if (this._articleContainer.articleUsage && !this._additionalOriginalUsageInfoProperties) {
      const propertyNames: string[] = [];
      this._additionalOriginalUsageInfoProperties.forEach((additionalOriginalUsageInfoProperty: PropertyVO) => {
        if (additionalOriginalUsageInfoProperty && additionalOriginalUsageInfoProperty.name) {
          propertyNames.push(additionalOriginalUsageInfoProperty.name);
        }
      });
      PropertyUtils.removePropertiesByNames(this._articleContainer.articleUsage.infoProperties, propertyNames);
    }
    ArticleUsageUtils.replaceArticleUsageInfoProperties(this._articleContainer.articleUsage, this._additionalNewUsageInfoProperties);
  }

  public async performUndo(): Promise<void> {
    this._selectionModelService.removeAllSelections();
    if (NumberUtils.isNumber(this._applyOriginalLength)) {
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(
        this._articleContainer.articleUsage,
        ArticleUsageInfoPropertyDef.ARTICLE_LENGTH,
        this._applyOriginalLength
      );
    }
    if (!this._additionalNewUsageInfoProperties && this._additionalOriginalUsageInfoProperties) {
      const propertyNames: string[] = [];
      this._additionalOriginalUsageInfoProperties.forEach((_additionalOriginalUsageInfoProperty) => {
        if (_additionalOriginalUsageInfoProperty && _additionalOriginalUsageInfoProperty.name) {
          propertyNames.push(_additionalOriginalUsageInfoProperty.name);
        }
      });
      this._additionalNewUsageInfoProperties = ArticleUsageUtils.getArticleUsageInfoProperties(
        this._articleContainer.articleUsage,
        propertyNames,
        true
      );
    }
    await this._replaceArticleService.replaceArticle(this._articleContainer, this._originalArticle);
    ArticleUsageUtils.replaceArticleUsageInfoProperties(
      this._articleContainer.articleUsage,
      this._additionalOriginalUsageInfoProperties
    );
  }
}
